import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.nav`
	padding: 24px 16px;
	position: sticky;
	top: 60px;
	height: calc(100vh - 61px);
	border-right: 1px solid ${helpers.color.border};
	background-color: ${helpers.color.background};

	@media only screen and (max-width: 750px) {
		width: 270px;
		z-index: 99;
		position: absolute;
		bottom: 0;
		height: unset;
		transition: left 135ms ease;
	}
`
